export const CREATE_MODE_ITEM_ID = '+' as const;
export type CreateModeItemId = typeof CREATE_MODE_ITEM_ID;
